export function removeDollarSign(s) {
  //console.log('in removeDollarSign: ' + s);
  if (!s)
    return 'NA';
  return s.toString().replace('$', '').split('.')[0];
}

export function removeDollarSignAndCommas(s) {
  //console.log('in removeDollarSign: ' + s);
  if (!s)
    return 'NA';
  return s.toString().replace('$', '').replace(',', '').split('.')[0];
}

export function formatTresCommas(val) {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function capitalizeFirstLetter(s) {
  if (s === 'bmw')
    return 'BMW';
  else if (s === 'Alfa Romeo')
    return 'AlfaRomeo'
  else if (s === 'Land Rover')
    return 'LandRover'
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function formatDate(d) {
  var _date  = new Date(d);
  return _date.toLocaleDateString("en-US"); // 9/17/2016
}

export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}



// WEBPACK FOOTER //
// ./src/helper.js